module.exports = __webpack_public_path__ + "static/Img4312DD4G-eba5dcb0b5d6656ffd3b1ef78215988f.png";